import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery, useTheme } from "@mui/material";
import { useContext, useState } from "react";
import { useAnalyticsLogging } from "../../../hooks/useAnalyticsLogging/useAnalyticsLogging";
import { useLogging } from "../../../hooks/useLogging/useLogging";
import { useCompanyConfigQuery } from "../../../../SWR/Company/useCompanyConfigQuery";
import { CustomizationModalStateContext } from "../../CustomizeModal/CustomizationContext";
import { handlePlusMinusClick } from "../utils/handlePlusMinusClick";
import { handleSingleSelectClick } from "../utils/handleSingleSelectClick";
import { PlusMinusControl } from "./PlusMinusControl";
import { SingleSelectControl } from "./SingleSelectControl";
export const CardQuantityControl = ({ hideControls, isSingleSelect, quantity, isSelectDisabled, selectedText, unselectedText, isAddDisabled, isMinusDisabled, setDialogContentMode, setOpenFromIncrement, assignmentCount, setIsDetailDialogOpen, openWhenMultipleAssignments, handleOpenCustomizeTab, handleCustomizeIncrement, handleCustomizeDecrement, handleToggle, handleQuantityDecrement, handleQuantityIncrement, openCustomizeModal, recipeHandlerProps_Three: RHP, isCustomizeModal, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const [isProcessingChange, setIsProcessingChange] = useState(false);
    const { setIsCustomizeModalOpen } = useContext(CustomizationModalStateContext);
    const { datadogLog } = useLogging();
    const { createKlaviyoEvent, logReactPixel } = useAnalyticsLogging();
    const { companyUsesKlaviyo, keyMap } = useCompanyConfigQuery();
    const reactPixelKey = keyMap.get("FacebookPixelId");
    if (hideControls)
        return null;
    if (isSingleSelect) {
        return (_jsx(SingleSelectControl, { onClick: () => handleSingleSelectClick({
                assignmentCount,
                companyUsesKlaviyo,
                createKlaviyoEvent,
                datadogLog,
                handleToggle,
                isProcessingChange,
                isSingleSelect,
                logReactPixel,
                openCustomizeModal,
                reactPixelKey,
                recipeHandlerProps_Three: RHP,
                setDialogContentMode,
                setIsCustomizeModalOpen,
                setIsDetailDialogOpen,
                setIsProcessingChange,
                setOpenFromIncrement,
                shouldOpenCustomizeModal: !isCustomizeModal && quantity === 0 && !!openCustomizeModal,
            }), selected: quantity > 0, disabled: isSelectDisabled, selectedText: selectedText, unselectedText: unselectedText }));
    }
    return (_jsx(PlusMinusControl, { handleAddClick: () => handlePlusMinusClick("add", {
            assignmentCount,
            companyUsesKlaviyo,
            createKlaviyoEvent,
            datadogLog,
            handleCustomizeDecrement,
            handleCustomizeIncrement,
            handleOpenCustomizeTab,
            handleQuantityDecrement,
            handleQuantityIncrement,
            isCustomizeModal,
            isProcessingChange,
            isSingleSelect,
            logReactPixel,
            openCustomizeModal,
            openWhenMultipleAssignments,
            quantity,
            reactPixelKey,
            recipeHandlerProps_Three: RHP,
            setDialogContentMode,
            setIsCustomizeModalOpen,
            setIsDetailDialogOpen,
            setIsProcessingChange,
            setOpenFromIncrement,
        }), handleMinusClick: () => handlePlusMinusClick("sub", {
            assignmentCount,
            companyUsesKlaviyo,
            createKlaviyoEvent,
            datadogLog,
            handleCustomizeDecrement,
            handleCustomizeIncrement,
            handleOpenCustomizeTab,
            handleQuantityDecrement,
            handleQuantityIncrement,
            isCustomizeModal,
            isProcessingChange,
            isSingleSelect,
            logReactPixel,
            openCustomizeModal,
            openWhenMultipleAssignments,
            quantity,
            reactPixelKey,
            recipeHandlerProps_Three: RHP,
            setDialogContentMode,
            setIsCustomizeModalOpen,
            setIsDetailDialogOpen,
            setIsProcessingChange,
            setOpenFromIncrement,
        }), quantity: quantity, isAddDisabled: isAddDisabled, isMinusDisabled: isMinusDisabled, size: isMobile ? "small" : "medium" }));
};
